import script from "./TrafficLightDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./TrafficLightDisplay.vue?vue&type=script&setup=true&lang=js"

import "./TrafficLightDisplay.vue?vue&type=style&index=0&id=39bea898&lang=scss"

const __exports__ = script;

export default __exports__